import { createClient } from "@supabase/supabase-js";

const fallbackSupabaseUrl = "https://mqhkjakdxnwtogurvnpd.supabase.co";
const fallbackSupabaseAnonKey = "sb_publishable_EvcdBBHCkFikf5Vx_fRxUg_c4U9qxOL";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.REACT_APP_CHURCH_SUPABASE_URL ||
  fallbackSupabaseUrl;

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_CHURCH_SUPABASE_ANON_KEY ||
  fallbackSupabaseAnonKey;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "oikos-auth-token",
  },
});

export default supabase;
